<template>
  <section class="viewsrhqyStoreManage_StoreQrcode">
    <viewTitle
      title="业务管理 / 基础数据管理 / 一码通管理"
      :showReturn="false"
    />
    <div class="dataDiv">
      <div class="imgDiv">
        <el-image
          style="width: 100%; height: 100%"
          fit="cover"
          :src="src[0]"
        ></el-image>
      </div>
      <div class="downloadList">
        <el-button @click="downloadDemo(src[0], '一码通8cm x 8cm')" type="text"
          >下载 8cm x 8cm</el-button
        >
        <br />
        <el-button
          @click="downloadDemo(src[1], '一码通12cm x 12cm')"
          type="text"
          >下载 12cm x 12cm</el-button
        >
        <br />
        <el-button
          @click="downloadDemo(src[2], '一码通15cm x 15cm')"
          type="text"
          >下载 15cm x 15cm</el-button
        >
        <br />
        <el-button
          @click="downloadDemo(src[3], '一码通30cm x 30cm')"
          type="text"
          >下载 30cm x 30cm</el-button
        >
        <br />
        <el-button
          @click="downloadDemo(src[4], '一码通50cm x 50cm')"
          type="text"
          >下载 50cm x 50cm</el-button
        >
      </div>
    </div>
  </section>
</template>

<script>
// 查询一码通接口
import viewTitle from "@/components/viewTitle";
export default {
  props: [""],

  data() {
    return {
      src: []
    };
  },

  computed: {},

  watch: {},

  components: { viewTitle },

  mixins: [],

  beforeRouteEnter(to, from, next) {
    next();
  },

  beforeRouteUpdate(to, from, next) {
    next();
  },

  beforeRouteLeave(to, from, next) {
    next();
  },

  beforeCreate() {},

  created() {
    this.$common
      .http({
        url: "/api/queue/basedata/list_code_images",
        data: {}
      })
      .then(res => {
        let data = res.data.data;
        Object.keys(data).forEach(val => {
          this.src.push(data[val]);
        });
      });
  },

  beforeMount() {},

  mounted() {},

  beforeUpdate() {},

  updated() {},

  activated() {},

  deactivated() {},

  beforeDestroy() {},

  destroyed() {},

  errorCaptured() {},

  methods: {
    downloadDemo(url, name) {
      this.$common.httpLoadFile({
        url: url,
        downloadName: name
      });
    }
  }
};
</script>
<style lang="less" scoped>
.viewsrhqyStoreManage_StoreQrcode {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  overflow: auto;
  .dataDiv {
    display: flex;
    align-items: center;
  }
  .imgDiv {
    width: 300px;
    height: 300px;
  }
  .downloadList {
    padding-left: 20px;
  }
}
</style>
<style lang="less">
.viewsrhqyStoreManage_StoreQrcode {
}
</style>
